import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Skeleton } from '../../../../common/skeleton/Skeleton';
import { useTranslation } from 'react-i18next';

const WaitingPeriodSkeleton = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="back-Injuries-card mb-4">
        <div className="benefit">
          <Card>
            <div className="benefit-card">
              <span className="min-benefit">
                {'Minimum Benefit'}
                <p className="benefit-card-pay">
                  <Skeleton height={14} count={1} />
                </p>
              </span>
              <span className="max-benefit">
                {'Maximum Benefit'}
                <p className="benefit-card-pay">
                  <Skeleton height={14} count={1} />
                </p>
              </span>
            </div>
            <div className="benefit-card">
              <span className="benefit-span-left">
                {'Benefit Allowed Period'}
              </span>
              <span className="benefit-span-right">
                <Skeleton height={14} width={126} count={1} />
              </span>
            </div>
            <div className="benefit-card border-0">
              <span className="benefit-span-left">
                {'Benefit Allowed Max Length'}
              </span>
              <span className="benefit-span-right">
                <Skeleton height={14} width={126} count={1} />
              </span>
            </div>
          </Card>
        </div>
        <div className="waiting-period">
          <Card>
            <div className="waiting-period-header">
              <h5 className="waiting-period-text">
                {t('member.pages.coverages.waiting_time')}
              </h5>
            </div>
            <div className="waiting-period-card">
              <span className="benefit-span-left">{'Accidental'}</span>
              <span className="benefit-span-right">
                <Skeleton height={14} width={126} count={1} />
              </span>
            </div>
            <div className="waiting-period-card">
              <span className="benefit-span-left">{'Illness'}</span>
              <span className="benefit-span-right">
                <Skeleton height={14} width={126} count={1} />
              </span>
            </div>
            <div className="waiting-period-card">
              <span className="benefit-span-left">{'Hospital'}</span>
              <span className="benefit-span-right">
                <Skeleton height={14} width={126} count={1} />
              </span>
            </div>
            <div className="waiting-period-card border-0">
              <span className="benefit-span-left">{'Others'}</span>
              <span className="benefit-span-right">
                <Skeleton height={14} width={126} count={1} />
              </span>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default WaitingPeriodSkeleton;
